"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONLINE_PAYMENT_WAIVER_NOTE_MAX_LENGTH = void 0;
exports.ONLINE_PAYMENT_WAIVER_NOTE_MAX_LENGTH = 1000;
